<div class="mfa-challenge">
  <p class="error" [innerHtml]="errorHtml"></p>
</div>
